import PuzzleLoop from './Root.vue';
import PuzzleLoopCreate from './views/PuzzleLoopCreate.vue';
import PuzzleLoopEdit from './views/PuzzleLoopEdit.vue';
import PuzzleLoopList from './views/PuzzleLoopList.vue';

export default {
  path: 'gerador/loop',
  name: 'admin-puzzle-loop',
  component: PuzzleLoop,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-puzzle-loop-list',
      component: PuzzleLoopList,
    },
    {
      path: 'novo/',
      name: 'admin-puzzle-loop-new',
      component: PuzzleLoopCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-puzzle-loop-edit',
      component: PuzzleLoopEdit,
    },
  ],
};
